import React from 'react';
import ExcessReturnContent from './content';
import { ExcessReturnProvider } from 'contexts/excess-returns.context';

const ExcessReturnLayout = () => {
  return (
    <ExcessReturnProvider>
      <ExcessReturnContent />
    </ExcessReturnProvider>
  );
};

export default ExcessReturnLayout;
